import { Chip, ChipPropsColorOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

type GangRole = 'leader' | 'member';

interface GangRoleBadgeProps {
  role: GangRole;
  size?: 'small' | 'medium';
  color?: OverridableStringUnion<
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'error',
    ChipPropsColorOverrides
  >;
}

const roleLabelMap: Record<GangRole, string> = {
  leader: 'Leader',
  member: 'Member',
};

export const GangRoleBadge = ({
  role,
  size = 'small',
  color,
}: GangRoleBadgeProps) => {
  const computedColor = color ?? (role === 'leader' ? 'primary' : 'default');

  return (
    <Chip
      label={roleLabelMap[role]}
      size={size}
      color={computedColor}
      variant={role === 'leader' ? 'filled' : 'outlined'}
    />
  );
};
